import { createSlice } from '@reduxjs/toolkit';

const clientSlice = createSlice({
  name: 'client',
  initialState: {
    clientID: localStorage.getItem('clientID') || null,
    patient: null,
  },
  reducers: {
    // Client reducers
    setClientID: (state, action) => {
      state.clientID = action.payload;
      localStorage.setItem('clientID', action.payload);
    },
    clearClientID: (state) => {
      state.clientID = null;
      localStorage.removeItem('clientID');
    },

    // Patient reducers
    setPatient: (state, action) => {
      state.patient = action.payload;
    },
    updatePatient: (state, action) => {
      state.patient = { ...state.patient, ...action.payload };
    },
    clearPatient: (state) => {
      state.patient = null;
    },
  },
});

export const { setClientID, setPatient, updatePatient, clearPatient, clearClientID } =
  clientSlice.actions;
export default clientSlice.reducer;
